import React from 'react';
import Section from '../components/common/Section';
import Container from '../components/common/Container';
import Button from '../components/common/Button';

const NotFound: React.FC = () => {
  return (
    <Section padding="xl">
      <Container>
        <div className="text-center">
          <h1 className="text-9xl font-black text-[var(--color-macaw)] mb-4">404</h1>
          <h2 className="text-3xl font-bold text-[var(--color-eel)] mb-4">Page Not Found</h2>
          <p className="text-xl text-[var(--color-wolf)] mb-8">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <Button to="/" size="lg">Back to Home</Button>
        </div>
      </Container>
    </Section>
  );
};

export default NotFound;
